import Image from "next/image"
import { originImgURL } from "../../listings-page-utils"

export function OwnerImage({ origin, className }) {
    const src = originImgURL[origin]
    return src ? <Image className={className} src={src} width={25} height={25} alt="listing owner logo" /> : null
}
/*
export function Owner({ listing }) {
    const url = new URL(listing.link)
    const name = url.hostname.replace(/^www\./, "")
    return (
        <a href={listing.link} className={styles.hostLink} target="_blank">
            {name}
            <OwnerImage src={listing.origin} />
        </a>
    )
}
*/
